import React, {Component} from 'react';

// Utilities
import stopPropagation from '../utilities/stopPropagation';

// Components
import ContactForm from './ContactForm';

const Modal = (props) => {
    const styleModal = {
        display: props.showModal
    }
    return (
    <div className="modalOverlay" onClick={props.click} style={styleModal}>
        <div className="Modal" onClick={stopPropagation}>
            <ContactForm toggleModal={props.click} />
        </div>        
    </div>
)}

export default Modal;


// WEBPACK FOOTER //
// ./src/components/Modal.js